<style>
.logo__wrapper {
  text-align: center;
}
.v-content {
  padding-top: 0 !important;
}
.logo__wrapper > img {
  height: 100px !important;
}
#login--alert {
  text-align: center;
  border-width: 0px !important;
  color: red;
}
#changePasswordBtn {
  padding-left: 10px;
}
#login-btn {
  float: right;
  margin-right: 5px;
}
#submit-btn {
  margin-bottom: 20px;
  margin-right: 0;
}
.logo__wrapper--desc {
  display: flex;
  text-align: center;
}
.logo__wrapper--desc p {
  color: rgba(0, 0, 0, 0.7);
  font-size: 16px;
}
</style>

<template>
  <v-container fluid fill-height @keydown.enter.prevent="logIn">
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-card-text>
            <div class="logo__wrapper">
              <img :src="require('@/logo.jpg')" />
            </div>
            <div class="logo__wrapper--desc">
              <p>Rejonowe Przedsiębiorstwo Komunalne Sp. z o.o. w Złotoryi</p>
            </div>
            <v-form>
              <v-text-field
                name="login"
                label="Login"
                type="text"
                v-model="login"
                id="login-field"
                :rules="[rules.required]"
              ></v-text-field>
              <v-text-field
                name="password"
                label="Hasło"
                id="password"
                type="password"
                v-model="password"
                :rules="[rules.required]"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <div id="login--alert">{{ errorMsg }}</div>
          <v-card-actions>
            <v-layout>
              <v-flex d-flex justify-space-between>
                <a id="changePasswordBtn" @click="passwordModalTrigger">Zmień hasło</a>
                <v-flex xs3>
                  <v-btn id="login-btn" small dark color="#2a579a" @click="logIn">Zaloguj</v-btn>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <modals-container />
  </v-container>
</template>

<script>
export default {
  data: () => ({
    login: "",
    password: "",
    error: false,
    loading: false,
    errorMsg: undefined,
    rules: {
      required: value => !!value || "Pole wymagane"
    }
  }),
  watch: {
    password(val) {
      this.errorMsg = "";
    }
  },
  mounted() {
    document.getElementById("login-field").focus();
  },
  methods: {
    logIn() {
      if (document.querySelector("#passRemindModal")) return;

      this.loading = true;
      let payload = {
        username: this.login,
        password: this.password
      };
      if (this.login == "" || this.password == "") {
        return;
      }
      this.$store.dispatch("getToken", payload).then(r => {
        this.loading = false;
        if (r.status == 200) {
          this.error = false;
          this.$store.dispatch("getUser");
          this.$router.push({ name: "viewer" });
        } else {
          this.error = true;
          this.errorMsg = r;
        }
      });
    },
    passwordModalTrigger() {
      this.$modal.show(
        {
          template: `
            <div id="passRemindModal" style="padding: 20px;" @keydown.enter.prevent="sendLink">
              {{ text }}
              <v-form v-model="valid">
                  <v-layout>
                    <v-flex
                      xs12
                    >
                      <v-text-field
                        v-model="email"
                        name="email"
                        :rules="emailRules"
                        label="E-mail użytkownika"
                        :error-messages="!response ? ['Podany adres email nie znajduje się w bazie'] : []"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
              </v-form>
              <p style="color:rgb(42, 87, 154)">{{ successText }}</p>

              <v-btn
                color="red"
                dark
                style="float: right"
                @click="closeModal"
              >
                ZAMKNIJ
              </v-btn>
              <v-btn
                color="rgb(42, 87, 154)"
                dark
                style="float:right"
                id="submit-btn"
                @click="sendLink"
              >
                WYŚLIJ
              </v-btn>
              
            </div>
          `,
          props: ["text"],
          data: () => ({
            email: "",
            emailRules: [
              v => !!v || "Adres e-mail jest wymagany",
              v => /.+@.+/.test(v) || "Niepoprawny format adresu e-mail"
            ],
            valid: false,
            response: true,
            successText: "",
            send: true
          }),
          watch: {
            email(val) {
              if (!this.response) this.response = !this.response;
            }
          },
          methods: {
            sendLink() {
              const self = this;
              let payload = {
                email: this.email
              };
              this.$store
                .dispatch("sendPasswordResetLink", payload)
                .then(res => {
                  if (!res) {
                    self.response = false;
                  } else {
                    this.successText = "Wysłano wiadomość!";
                    this.send = false;
                  }
                });
            },
            closeModal() {
              this.$modal.hide("sendMailModal");
            }
          }
        },
        {
          text:
            "W celu zmiany swojego hasła, wpisz e-mail połączony z kontem użytkownika. Na podany adres otrzymasz link do zmiany hasła."
        },
        {
          height: "auto",
          name: "sendMailModal"
        },
        {
          "before-close": event => {
            this.successText = "";
            this.send = true;
          }
        }
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/login/Login.vue